export class Navigation {
    title: string;
    route: string;

    static getCandidateNavigations(): Navigation[] {
        return [
            { title: "Profile", route: "/candidate/profile" },
            { title: "Portfolio", route: "/candidate/resume" },
            { title: "Search Jobs", route: "/search-jobs" },
            { title: "Manage Jobs", route: "/candidate/manage-jobs" },
            { title: "Change Password", route: "/candidate/change-password" },
            { title: "Messages", route: "/candidate/notifications" },
            { title: "Log Out", route: "/signout" },
        ];
    }

    static getEmployerNavigations(): Navigation[] {
        return [
            { title: "Profile", route: "/employer/profile" },
            { title: "Manage Jobs", route: "/employer/manage-jobs" },
            { title: "Post New Job", route: "/employer/post-job" },
            { title: "Change Password", route: "/employer/change-password" },
            { title: "Messages", route: "/employer/notifications" },
            { title: "Log Out", route: "/signout" },
        ];
    }
}
